'use strict';

import Server from 'helpers/server';
import Events from 'events/events';
import { dataset } from '../polyfills/dataset';
import Analytics from 'helpers/analytics/analytics';
import { dispatchEvent } from 'helpers/analytics/AnalyticsEventDispatcher';
import DomUtils from 'helpers/dom-utils';

if (canEnhanceListingPageAddToBasketForms()) {
  initAddToBasket();
}

function initAddToBasket() {
  addToBasketButtonListeners();
}

function canEnhanceListingPageAddToBasketForms() {
  return (
    'querySelector' in document &&
    document.querySelector('.standard-product-list-page-body .add-to-basket-component')
  );
}

function addToBasketButtonListeners() {
  let addToBasketForms = document.querySelectorAll('.add-to-basket-component');

  addToBasketForms.forEach((form) => {
    let button = form.querySelector('.button');
    button.addEventListener('click', evt => {
      evt.preventDefault();
      toggleLoader(button);
      Events.onAddToBasket.trigger(window, null);
      addToBasket(form);
    });
    let select = form.querySelector('.pretty-select');
    if(select){
      select.addEventListener('change', evt => {
        const selectedSku = select.options[select.selectedIndex].value;
        form.setAttribute('action', `/basket/${selectedSku}`);
      });
    }
  })
}

function addToBasket(form) {
  Server.getHtml(form.getAttribute('action'), {
    method: 'POST',
    body: new FormData(form),
    credentials: 'same-origin'
  })
    .then((response) => updateAnalytics(response, form))
    .then(() => {
      //event dispatched globally to trigger an action to update the user profile in the browse-ui header
      const basketQuantityUpdated = DomUtils.createEvent({
        eventName: 'jl-events.browser.basketQuantityUpdated',
        element: window
      })
      basketQuantityUpdated.dispatch()
      Events.basketQuantityUpdated.trigger(window, null)
    })
    .then(() => toggleLoader(form.querySelector('button')));
}

function updateAnalytics(response, form) {

  let formData = dataset(form);

  let Addinfo = {
    itemPrice: formData.price,
    productId: formData.product,
    qty: form.querySelector('.quantity-input').value,
    services: [],
    sku: formData.sku
  }

  dispatchEvent('dataStateChange', { action: 'range.addtobasket', Addinfo });
  Analytics.updateAnalyticsFromResponse(response);
}

function toggleLoader(button) {
  button.classList.toggle('u-button-loader');
  button.classList.toggle('button--loading');
}
